import {
  AudioRecordingModelData,
  AudioRecordingRecordingStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkCompletedLocalAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_COMPLETED_LOCAL_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    _existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    return {
      recording_status: AudioRecordingRecordingStatus.COMPLETED,
    };
  }
}
